(() => {
  /**
   * Map discount codes -> product URL paths that should trigger that code.
   * Use URL *paths* only (no domain), e.g. "/products/my-handle"
   */
  const DISCOUNT_URL_MAP = {
    /* "STARTER-PACK": [
      "/products/citrus-pear-starter-kit",
      // "/products/another-handle",
    ], */

    // EXAMPLE2: [
    //   "/products/some-other-product",
    //   "/products/some-other-product-2",
    // ],
  };

  /**
   * Matching behavior:
   * - "exact": pathname must exactly equal an entry in the list
   * - "prefix": pathname must start with an entry in the list
   */
  const MATCH_MODE = "exact"; // "exact" | "prefix"

  // ----------------- logic -----------------
  const { pathname, search, hash } = window.location;

  // Don't interfere with Shopify's discount setter route
  if (pathname.startsWith("/discount/")) return;

  const entries = Object.entries(DISCOUNT_URL_MAP);

  // Find the first discount code whose URL list matches this page
  let matchedCode = null;

  for (const [code, paths] of entries) {
    if (!Array.isArray(paths) || !paths.length) continue;

    const hit =
      MATCH_MODE === "prefix"
        ? paths.some((p) => pathname.startsWith(p))
        : paths.some((p) => pathname === p);

    if (hit) {
      matchedCode = code;
      break;
    }
  }

  if (!matchedCode) return;

  // Prevent infinite redirects (per-code + per-page, per session)
  const key = `autoDiscountApplied::${matchedCode}::${pathname}`;
  if (sessionStorage.getItem(key)) return;

  sessionStorage.setItem(key, "1");

  // Preserve current URL (including query/hash) after discount is set
  const currentUrl = pathname + search + hash;

  // Redirect through Shopify discount setter
  const discountUrl = `/discount/${encodeURIComponent(matchedCode)}?redirect=${encodeURIComponent(
    currentUrl
  )}`;

  window.location.replace(discountUrl);
})();
